import { watchImmediate } from "@vueuse/core";
import { reactive } from "vue";
import { t } from "#ce/shared/components-i18n";
import { createMetaDataApi } from "#ce/apps/SpAdmin/SpTargetSelectorApp/api/meta-data";

/**
 * Describes the record an internal link names, refetching whenever the link changes.
 *
 * @param {() => String} sparkleUrl
 * @returns {{ preview: {iconName: String, label: String, url: String} }}
 */
export function useTargetPreview(sparkleUrl) {
  const metaDataApi = createMetaDataApi();
  const preview = reactive({ iconName: "", label: "", url: "" });

  async function load() {
    const requested = sparkleUrl();

    preview.iconName = "";
    preview.url = "";

    if (!requested) {
      preview.label = "";
      return;
    }

    preview.label = t("target_selector_preview_loading");

    const data = await metaDataApi.findTarget(requested);

    // A pick made while this was in flight owns the preview, and its own request will land.
    if (requested !== sparkleUrl()) {
      return;
    }

    if (!data) {
      preview.label = t("target_selector_preview_unavailable");
      return;
    }

    preview.iconName = data.iconName;
    preview.label = data.label;
    preview.url = data.url;
  }

  watchImmediate(sparkleUrl, load);

  return { preview };
}
